export { ScrollShadowContainer } from "ics-ui-kit/components/scroll-shadow-container";
export { LegacyScrollShadowContainer } from "./LegacyScrollShadowContainer";
